import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
`;

export const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 1.5rem;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const Footer = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .quantites {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0 auto 0 auto;
  }
`;

export const ActionsContainer = styled.div`
  width: 60%;

  & div {
    display: flex;

    & :first-child {
      margin-right: 1rem;
    }
  }
`;
